import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiBaseUrl, apiRoots } from 'src/config';

export interface AssetKpi {
  numberActiveSerialTasks: number;
  numberActiveTasks: number;
  numberTasksHighPriority: number;
  numberTasksOverdue: number;
}

export interface AssetKpiBatchResponse {
  [id: string]: AssetKpi;
}

@Injectable()
export class KpiApi {
  private readonly http = inject(HttpClient);

  machineKpiUrl = apiBaseUrl + apiRoots.machineKpi;
  toolingKpiUrl = apiBaseUrl + apiRoots.toolingKpi;

  /**
   * Get kpis for the given machine
   */
  getMachineKpis$(id: string): Observable<AssetKpi> {
    return this.http.get<AssetKpi>(this.machineKpiUrl + '/' + id);
  }

  /**
   * Get kpis for the given machine ids
   */
  getMachineKpisBatch$(ids: string[]): Observable<AssetKpiBatchResponse> {
    return this.http.post<AssetKpiBatchResponse>(this.machineKpiUrl, ids);
  }

  /**
   * Get kpis for the given tooling
   */
  getToolingKpis$(id: string): Observable<AssetKpi> {
    return this.http.get<AssetKpi>(this.toolingKpiUrl + '/' + id);
  }

  /**
   * Get kpis for the given tooling ids
   */
  getToolingKpisBatch$(ids: string[]): Observable<AssetKpiBatchResponse> {
    return this.http.post<AssetKpiBatchResponse>(this.toolingKpiUrl, ids);
  }
}
